import {
  GET_CUSTOMER_SERVICE,
  GET_CUSTOMER_SERVICE_SUCCESS,
  GET_CUSTOMER_SERVICE_FAIL,
  ADD_CUSTOMER_SERVICE,
  ADD_CUSTOMER_SERVICE_SUCCESS,
  ADD_CUSTOMER_SERVICE_FAIL,
  UPDATE_CUSTOMER_SERVICE,
  UPDATE_CUSTOMER_SERVICE_SUCCESS,
  UPDATE_CUSTOMER_SERVICE_FAIL,
  DELETE_CUSTOMER_SERVICE,
  DELETE_CUSTOMER_SERVICE_SUCCESS,
  DELETE_CUSTOMER_SERVICE_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL CUSTOMER SERVICE LIST
export const getCustomerService = () => ({
  type: GET_CUSTOMER_SERVICE,
})
export const getCustomerServiceSuccess = service => ({
  type: GET_CUSTOMER_SERVICE_SUCCESS,
  payload: service,
})
export const getCustomerServiceFail = error => ({
  type: GET_CUSTOMER_SERVICE_FAIL,
  payload: error,
})

// ADD NEW PROBLEM TO CUSTOMER SERVICE TABLE
export const addCustomerService = custService => ({
  type: ADD_CUSTOMER_SERVICE,
  payload: custService,
})
export const addCustomerServiceSuccess = custService => ({
  type: ADD_CUSTOMER_SERVICE_SUCCESS,
  payload: custService,
})
export const addCustomerServiceFail = error => ({
  type: ADD_CUSTOMER_SERVICE_FAIL,
  payload: error,
})

// UPDATE PROBLEM INSIDE CUSTOMER SERVICE LIST
export const updateCustomerService = custService => ({
  type: UPDATE_CUSTOMER_SERVICE,
  payload: custService,
})
export const updateCustomerServiceSuccess = custService => ({
  type: UPDATE_CUSTOMER_SERVICE_SUCCESS,
  payload: custService,
})
export const updateCustomerServiceFail = error => ({
  type: UPDATE_CUSTOMER_SERVICE_FAIL,
  payload: error,
})

// DELETE PROBLEM FROM CUSTOMER SERVICE LIST
export const deleteCustomerService = custService => ({
  type: DELETE_CUSTOMER_SERVICE,
  payload: custService,
})
export const deleteCustomerServiceSuccess = custService => ({
  type: DELETE_CUSTOMER_SERVICE_SUCCESS,
  payload: custService,
})
export const deleteCustomerServiceFail = error => ({
  type: DELETE_CUSTOMER_SERVICE_FAIL,
  payload: error,
})

export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})
